var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入用户名", type: "text" },
            model: {
              value: _vm.searchData.userName,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "userName", $$v)
              },
              expression: "searchData.userName"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入联系电话", type: "text" },
            model: {
              value: _vm.searchData.mobile,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "mobile", $$v)
              },
              expression: "searchData.mobile"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _vm.checkPermission(["admin:admin:save"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "45" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "320", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["admin:admin:edit"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "info",
                              title: "查看",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.lookView(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["admin:admin:save"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "编辑",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["admin:admin:del"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["admin:admin:save"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              title: "修改密码",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updatePwdFun(scope.row)
                              }
                            }
                          },
                          [_vm._v("修改密码")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "500px",
            visible: _vm.newadd,
            "before-close": _vm.closeRefund,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户名", prop: "userName" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "15" },
                    model: {
                      value: _vm.addData.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "userName", $$v)
                      },
                      expression: "addData.userName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      disabled: _vm.title != "新增",
                      maxlength: "15",
                      placeholder: "请输入6位以上的密码"
                    },
                    model: {
                      value: _vm.addData.password,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "password", $$v)
                      },
                      expression: "addData.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "确认密码", prop: "confirmPwd" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      disabled: _vm.title != "新增",
                      maxlength: "15"
                    },
                    model: {
                      value: _vm.addData.confirmPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "confirmPwd", $$v)
                      },
                      expression: "addData.confirmPwd"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色", prop: "roleId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择角色" },
                      on: { change: _vm.changeRole },
                      model: {
                        value: _vm.addData.roleId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "roleId", $$v)
                        },
                        expression: "addData.roleId"
                      }
                    },
                    _vm._l(_vm.rolesData, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.roleName, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "姓名" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "15" },
                    model: {
                      value: _vm.addData.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "nickName", $$v)
                      },
                      expression: "addData.nickName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "性别" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.addData.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "sex", $$v)
                        },
                        expression: "addData.sex"
                      }
                    },
                    [_vm._v("男")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "2" },
                      model: {
                        value: _vm.addData.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "sex", $$v)
                        },
                        expression: "addData.sex"
                      }
                    },
                    [_vm._v("女")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "11" },
                    model: {
                      value: _vm.addData.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "mobile", $$v)
                      },
                      expression: "addData.mobile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20" },
                    model: {
                      value: _vm.addData.email,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "email", $$v)
                      },
                      expression: "addData.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "机构名称", prop: "insId" } },
                [
                  _c("Mechanism", {
                    ref: "mechanRef",
                    attrs: {
                      id: "mechanRef",
                      mechanismValue: _vm.addData.insId
                    },
                    on: { relMechanism: _vm.changeMechanism }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "isblock", attrs: { label: "是否禁用" } },
                [
                  _c("el-checkbox", {
                    attrs: { "false-label": 1, "true-label": 0 },
                    model: {
                      value: _vm.addData.status,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "status", $$v)
                      },
                      expression: "addData.status"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "查看"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("关闭")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "编辑"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("关闭")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.updatePwd,
            width: "500px",
            "before-close": _vm.closePwd,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.updatePwd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "pwdForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: { type: "password" },
                    model: {
                      value: _vm.addData.password,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "password", $$v)
                      },
                      expression: "addData.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "确认密码", prop: "confirmPwd" } },
                [
                  _c("el-input", {
                    attrs: { type: "password" },
                    model: {
                      value: _vm.addData.confirmPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "confirmPwd", $$v)
                      },
                      expression: "addData.confirmPwd"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.upSubmit } },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.upCencal } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }